/**
 * @fileOverView
 * @description Vyb Full View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var VybTemplate = require('../../templates/widgets/vybfulltemplate.html');
var config = require("../../etc/config");
var Params = require("../../collections/params");
var ParamView = require("./param");
var VybLogsView = require('../widgets/vyblogsview');
var eventUriCopyButton = require('../../templates/components/eventUriCopyButton.html');
var app = require("ampersand-app");
var dialog = require("../../lib/dialog");
var limits = require("../../../../lib/notificationlimits");
var moment = require('moment-timezone');

var VybFullView = AmpersandView.extend({

    template: VybTemplate,

    initialize: function(options){

        var entity = 'vyb';

        var soundParam = {
                "entity" : entity,
                "name" : "soundName",
                "label" : "SOUND",
                "inputType" : "page",
                "placeholder" : "none - find the perfect sound, choose wisely",
                "cursor" : true
            };
        if(options.action=="showSound") soundParam.doNotHide = true;

        this.generalSettings = new Params([
            {
               "entity" : entity,
               "name" : "name",
               "label" : "NAME",
               "inputType" : "text",
               "template" : "TextTemplate",
               "placeholder" : "start with a fantastic name",
               "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "status",
                "label" : "OFF/ON",
                "inputType" : "checkbox"
            },

            soundParam,

            {
                "entity" : entity,
                "name" : "description",
                "label" : "DESCRIPTION",
                "inputType" : "text",
                "template" : "TextTemplate",
                "placeholder" : "an optional description for you and potential subscribers",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "delete",
                "label" : "",
                "inputType" : "button",
                "template" : "VybDeleteTemplate",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "docCreateLink",
                "label" : "HELP",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : false,
                "doNotHide" : true
            },

            //polling parameters
            /*   {
        "entity" : entity,
        "name" : "type",
        "label" : "TYPE",
        "inputType" : "select",
        "template" : "VybTypeTemplate"
    },
    {
        "entity" : entity,
        "name" : "pollUri",
        "label" : "POLL URI",
        "inputType" : "text",
        "template" : "TextTemplate"
    },
    {
        "entity" : entity,
        "name" : "frequency",
        "label" : "POLL FREQUENCY",
        "inputType" : "select",
        "template" : "VybFrequencyTemplate"
    },

   {
         "entity" : entity,
        "name" : "diagnostics",
        "label" : "TEST DIAGNOSTICS",
        "inputType" : "none",
        "template" : "DisplayTemplate",
        "cursor" : true,
        "hidden" : true
    },
    */

        ]);

        this.triggerSettingsInit = [
            {
                "entity" : entity,
                "name" : "eventUri",
                "label" : "TRIGGER URI",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : false,
                "rightColContent" : eventUriCopyButton(),
                "labelNoWrap": true
            },
            {
                "entity" : entity,
                "name" : "triggerType",
                "label" : "TRIGGER TYPE",
                "inputType" : "select",
                "template" : "TriggerTypeTemplate",
                "labelNoWrap": true,
                "cursor" : true
            },
        ];

        this.triggerSettingComponents = {
            integrationLinks: {
                "entity" : entity,
                "name" : "integrationLinks",
                "label" : "INTEGRATIONS",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : true
            },
            schedule: {
                "entity" : entity,
                "name" : "schedule",
                "label" : "SCHEDULE",
                "inputType" : "none",
                "template" : "ScheduleEditTemplate",
                "cursor" : true,
                "bypassSave" : true
            },
            geofence: {
                "entity" : entity,
                "name" : "geofenceDisplay",
                "label" : "GEOFENCE",
                "inputType" : "none",
                "template" : "GeofenceEditTemplate",
                "cursor" : true,
                "bypassSave" : true
            },
            reminders: {
                "entity" : entity,
                "name" : "reminders",
                "label" : "REMINDERS",
                "inputType" : "none",
                "template" : "ReminderEditTemplate",
                "cursor" : true,
                "bypassSave" : true
            },
            help: {
                "entity" : entity,
                "name" : "docTriggerLink",
                "label" : "HELP",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : false,
                "doNotHide" : true
            },
        },

        this.notificationSettings = new Params([
            {
                "entity" : entity,
                "name" : "message",
                "label" : "MESSAGE",
                "inputType" : "textarea",
                "template" : "TextAreaTemplate",
                "placeholder" : "an optional default message to send with the notification",
                "maxLength" : limits.MESSAGE_MAX_LENGTH,
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "imageUrl",
                "label" : "IMAGE URL",
                "inputType" : "text",
                "template" : "TextTemplate",
                "placeholder" : "optional image URL (.jpg, .jpeg, or .png, under 1MB)",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "linkUrl",
                "label" : "LINK URL",
                "inputType" : "text",
                "template" : "TextTemplate",
                "placeholder" : "an optional redirect url when the vybit notification is tapped",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "log",
                "label" : "LOG",
                "inputType" : "textarea",
                "template" : "TextAreaTemplate",
                "placeholder" : "optional default details to save in the notification log (plain text)",
                "maxLength" : limits.LOG_MAX_LENGTH,
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "test",
                "label" : "",
                "inputType" : "button",
                "template" : "VybTestTemplate",
                "cursor" : true,
                "rightColContent" : '<div class="vcolright"><button class="btn btn-secondary btn-sm vclearfields">CLEAR FIELDS</button></div>'
            }
        ]);

        this.subscriptionSettings = new Params([
            {
                "entity" : entity,
                "name" : "subscriptionLinks",
                "label" : "SUBSCRIPTION LINKS",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : true,
                "rightColContent" : app.vyb.subscriptionCopyButtons
            },
            {
                "entity" : entity,
                "name" : "access",
                "label" : "SUBSCRIPTION ACCESS",
                "inputType" : "select",
                "template" : "VybAccessTemplate",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "sendPermissions",
                "label" : "SEND PERMISSIONS",
                "inputType" : "select",
                "template" : "SendPermissionsTemplate",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "moderationDisplay",
                "label" : "MODERATION",
                "inputType" : "none",
                "cursor" : true,
                "template" : "DisplayTemplate",
                "bypassSave" : true
            },
            {
                "entity" : entity,
                "name" : "displayFollowers",
                "label" : "PEEPS",
                "inputType" : "page",
                "placeholder" : "invite people to subscribe to this vybit",
                "cursor" : true
            },
            {
                "entity" : entity,
                "name" : "docSubscriptionLink",
                "label" : "HELP",
                "inputType" : "none",
                "template" : "DisplayTemplate",
                "cursor" : false,
                "doNotHide" : true
            },
        ]);

        this.listenToAndRun(this.model,'change:triggerType',function(){
            this.renderTriggerSettings();
        });

        this.listenTo(this.model,'change:triggerSettings',function(){
            this.updateRunOnceToggle();
        });
    },

    render: function(){
        this.renderWithTemplate();
        this.renderCollection(this.generalSettings,ParamView,'div.vset-general');
        this.renderTriggerSettings();
        this.renderCollection(this.notificationSettings,ParamView,'div.vset-notification');
        this.renderCollection(this.subscriptionSettings,ParamView,'div.vset-subscription');
    },

    renderTriggerSettings: function(){
        let triggerSettingsList = [...this.triggerSettingsInit];
        if(app.vyb.triggerType=="schedule") triggerSettingsList.push(this.triggerSettingComponents.schedule);
        else if(app.vyb.triggerType=="integration") triggerSettingsList.push(this.triggerSettingComponents.integrationLinks);
        else if(app.vyb.triggerType=="geofence") triggerSettingsList.push(this.triggerSettingComponents.geofence);
        else if(app.vyb.triggerType=="reminders") triggerSettingsList.push(this.triggerSettingComponents.reminders);
        triggerSettingsList.push(this.triggerSettingComponents.help);

        this.triggerSettings = new Params(triggerSettingsList);
        if(this.query('div.vset-trigger')) this.query('div.vset-trigger').innerHTML = '';

        this.renderCollection(this.triggerSettings,ParamView,'div.vset-trigger');

        // Append runOnce toggle row
        var triggerDiv = this.query('div.vset-trigger');
        if(triggerDiv){
            var runOnceRow = document.createElement('div');
            runOnceRow.className = 'vrow vparamrow vrunonce-row';
            var checked = app.vyb.runOnceOn ? 'checked' : '';
            runOnceRow.innerHTML =
                '<label class="vcol vlabel vlabel-no-wrap">RUN ONCE</label>' +
                '<div class="vcol vfcol vmid vstatus" style="display:flex;align-items:center">' +
                    '<div class="switch">' +
                        '<input id="runonce-toggle" class="cmn-toggle cmn-toggle-round-flat" type="checkbox" ' + checked + ' />' +
                        '<label class="vswitchlabel vrunonce-label" for="runonce-toggle"></label>' +
                    '</div>' +
                    '<span class="vplaceholder" style="margin-left:8px">turn off this vybit when the notification is received</span>' +
                '</div>' +
                '<div class="vcol vright"></div>';
            // Insert before the help param (last child)
            var helpRow = triggerDiv.lastElementChild;
            triggerDiv.insertBefore(runOnceRow, helpRow);
        }
    },

    updateRunOnceToggle: function(){
        var cb = this.query('#runonce-toggle');
        if(cb) cb.checked = app.vyb.runOnceOn;
    },

    bindings: {
       "model.hideSettings" : {
           type: "booleanClass",
           selector: "div.vsettings-accordian",
           name: "vhide"
       }
    },

    events: {
        "click .vschedule-add-btn" : "addSchedule",
        "click .vschedule-delete" : "deleteSchedule",
        "click .vgeofence-save" : "saveGeofence",
        "click .vclearfields" : "clearNotificationFields",
        "click .vrunonce-label" : "saveRunOnce",
        "click .vreminder-add-btn" : "addReminder",
        "click .vreminder-delete" : "deleteReminder"
    },

    saveRunOnce: function(){
        var ts = Object.assign({}, app.vyb.triggerSettings || {});
        ts.runOnce = !ts.runOnce;
        app.vyb.set('triggerSettings', ts);
        app.vyb.patch({triggerSettings: ts});
    },

    addSchedule: function(){
        var container = document.querySelector('.vts-schedule-edit');
        if (!container) return;

        var errorEl = container.querySelector('.vts-schedule-error');
        if (errorEl) errorEl.textContent = '';

        var card = container.querySelector('[data-hook="schedule_add_card"] .vts-card');
        if (!card) return;

        var freq = card.querySelector('.vts-freq-select').value;
        var config = {frequency: freq, times: [], selectedDays: [], selectedDoms: [], selectedMonths: [], interval: {}};

        if (freq === 'interval') {
            var n = parseInt(card.querySelector('.vts-interval-n').value);
            var offset = parseInt(card.querySelector('.vts-interval-offset').value) || 0;
            var hourMode = card.querySelector('.vts-hour-mode').value;
            var hourStart = null, hourEnd = null;
            if (hourMode === 'custom') {
                hourStart = parseInt(card.querySelector('.vts-hour-start').value);
                hourEnd = parseInt(card.querySelector('.vts-hour-end').value);
            }
            config.interval = {n: n, offset: offset, hourStart: hourStart, hourEnd: hourEnd};
            config.selectedDays = app.utils._readActiveToggles(card, '.vts-dow-section');
        } else {
            card.querySelectorAll('.vts-time-row').forEach(function(row) {
                var h = parseInt(row.querySelector('.vts-time-hour').value);
                var m = parseInt(row.querySelector('.vts-time-minute').value);
                var ampm = row.querySelector('.vts-time-ampm').value;
                if (ampm === 'PM' && h !== 12) h += 12;
                if (ampm === 'AM' && h === 12) h = 0;
                config.times.push({hour: h, minute: m});
            });

            if (freq === 'weekly' || freq === 'yearly') {
                config.selectedDays = app.utils._readActiveToggles(card, '.vts-dow-section');
            }
            if (freq === 'monthly' || freq === 'yearly') {
                config.selectedDoms = app.utils._readActiveToggles(card, '.vts-dom-section');
            }
            if (freq === 'yearly') {
                config.selectedMonths = app.utils._readActiveToggles(card, '.vts-month-section');
            }
        }

        var cronStr = app.utils.scheduleConfigToCron(config);
        var timeZone = container.querySelector("select[name='cron_timezone']").value;

        var ts = JSON.parse(JSON.stringify(app.vyb.triggerSettings || {}));
        if (!ts.crons) ts.crons = [];
        ts.crons.push({cron: cronStr, timeZone: timeZone});

        // Set triggers change:schedule → vparam re-renders list + add card via configScheduleSettings
        app.vyb.set('triggerSettings', ts);

        // PATCH via ajax to avoid vyb.patch() setting editing=false
        jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/vyb/' + app.vyb.key,
            type: 'PATCH',
            contentType: 'application/json',
            data: JSON.stringify({triggerSettings: ts}),
            error: function() { console.log('Error saving schedule'); }
        }, app.utils.setAuthTokenHeader()));
    },

    deleteSchedule: function(e){
        var idx = e.target.dataset.scheduleIndex || (e.target.closest('.vschedule-delete') && e.target.closest('.vschedule-delete').dataset.scheduleIndex);
        if (idx === undefined || idx === null) return;
        idx = parseInt(idx);

        var ts = JSON.parse(JSON.stringify(app.vyb.triggerSettings || {}));
        if (ts.crons) ts.crons.splice(idx, 1);

        // Set triggers change:schedule → vparam re-renders list via configScheduleSettings
        app.vyb.set('triggerSettings', ts);

        // PATCH via ajax to avoid vyb.patch() setting editing=false
        jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/vyb/' + app.vyb.key,
            type: 'PATCH',
            contentType: 'application/json',
            data: JSON.stringify({triggerSettings: ts}),
            error: function() { console.log('Error deleting schedule'); }
        }, app.utils.setAuthTokenHeader()));
    },

    saveGeofence: function(){

        let location = this.query("input[name='glocation']").value;
        location = location.replace(/[ \(\)]/g,"");

        //parse location from map link
        let mapRegex = /[0-9\-][0-9\.]{1,},[0-9\-][0-9\.]{1,}/;
        if(location.match(mapRegex)){
            location = location.match(mapRegex)[0];
            console.log('found location in link: ' + location);
        }

        let latlon = location.split(",");
        let lat = latlon[0];
        let lon = latlon[1];
        let radius = this.query("input[name='gradius']").value;
        let radius_units = this.query("select[name='gradius_units']").value;
        let type = this.query("select[name='gtype']").value;
        let timeThrottle = this.query("input[name='gtime']").value;
        let subscribable = this.query("select[name='gsub']").value;

        //validate
        let regex1 = /^(-|)[\.0-9]+$/;
        let regex2 = /^[0-9\.]{1,}$/;

        if(lat.match(regex1)==null){ dialog.alert("Invalid value for latitude."); return; }
        if(lon.match(regex1)==null){ dialog.alert("Invalid value for longitude."); return; }
        if(radius.match(regex2)==null){ dialog.alert("Invalid value for radius."); return; }
        if(timeThrottle.match(regex2)==null){ dialog.alert("Invalid value for reset threshold."); return; }

        //convert radius to meters
        let displayRadius = radius;
        if(radius_units==="kilometers") radius = radius*1000;
        else if(radius_units==="miles") radius = radius*1609.34;
        radius = parseFloat(radius);
        if(radius < 100.00){
            radius = parseFloat(100.0);
            displayRadius = 100;
            if(radius_units==="kilometers") displayRadius = radius/1000;
            if(radius_units==="miles") displayRadius = (radius/1609.34).toPrecision(4);
        }

        var payload = {
                    id: app.vyb.key,
                    lat: parseFloat(lat),
                    lon: parseFloat(lon),
                    radius: radius.toFixed(6)*1,
                    radiusUnits: radius_units,
                    displayRadius: displayRadius,
                    type: type,
                    timeThrottle: timeThrottle,
                    subscribable: subscribable
        };

        app.vyb.set('geofence',payload);
        app.vyb.patch({geofence: payload});
        app.header.set('editing',false);
        this.renderTriggerSettings();
    },

    addReminder: function(){
        var container = document.querySelector('.vts-reminder-edit');
        if (!container) return;

        var errorEl = container.querySelector('.vts-reminder-error');
        errorEl.textContent = '';

        var dateVal = container.querySelector('.vreminder-date-input').value;
        if (!dateVal) { errorEl.textContent = 'Please select a date.'; return; }

        var hour = parseInt(container.querySelector('.vreminder-hour').value);
        var minute = parseInt(container.querySelector('.vreminder-minute').value);
        var ampm = container.querySelector('.vreminder-ampm').value;
        var timeZone = container.querySelector('.vreminder-timezone').value;

        // Convert to 24h
        if (ampm === 'PM' && hour !== 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;

        // Validate date is in the future and within one year
        var parts = dateVal.split('-');
        var year = parseInt(parts[0]);
        var month = parseInt(parts[1]);
        var day = parseInt(parts[2]);
        var reminderMoment = moment.tz({year: year, month: month - 1, date: day, hour: hour, minute: minute}, timeZone);
        if (reminderMoment.isBefore(moment())) {
            errorEl.textContent = 'Reminder must be in the future.';
            return;
        }
        // Use plain Date comparison as well for robustness
        var reminderDate = new Date(year, month - 1, day, hour, minute);
        var oneYearOut = new Date();
        oneYearOut.setFullYear(oneYearOut.getFullYear() + 1);
        if (reminderMoment.isAfter(moment().add(1, 'year')) || reminderDate > oneYearOut) {
            errorEl.textContent = 'Reminder must be within one year from today.';
            return;
        }

        var cron = minute + ' ' + hour + ' ' + day + ' ' + month + ' *';

        var payload = {
            cron: cron,
            timeZone: timeZone,
            year: year
        };

        var message = container.querySelector('.vreminder-message').value.trim();
        var imageUrl = container.querySelector('.vreminder-imageurl').value.trim();
        var linkUrl = container.querySelector('.vreminder-linkurl').value.trim();
        if (imageUrl) {
            imageUrl = imageUrl.match(/^https?:\/\//) ? imageUrl : 'https://' + imageUrl;
            if (!app.utils.isValidURL(imageUrl)) { errorEl.textContent = 'Invalid image URL.'; return; }
            payload.imageUrl = imageUrl;
        }
        if (linkUrl) {
            linkUrl = linkUrl.match(/^https?:\/\//) ? linkUrl : 'https://' + linkUrl;
            if (!app.utils.isValidURL(linkUrl)) { errorEl.textContent = 'Invalid link URL.'; return; }
            payload.linkUrl = linkUrl;
        }
        if (message) payload.message = message;

        var self = this;
        jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/vyb/' + app.vyb.key + '/reminders',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: function(response) {
                if (response.result === 1) {
                    app.vyb.updateTriggerSettings(function(ts){
                        if (!ts.reminders) ts.reminders = [];
                        ts.reminders.push(response.reminder);
                    });
                } else {
                    errorEl.textContent = response.message || 'Error adding reminder.';
                }
            },
            error: function(xhr) {
                var resp = xhr.responseJSON || {};
                errorEl.textContent = resp.message || 'Error adding reminder.';
            }
        }, app.utils.setAuthTokenHeader()));
    },

    deleteReminder: function(e){
        var reminderId = e.target.dataset.reminderId || e.target.closest('.vreminder-delete').dataset.reminderId;
        if (!reminderId) return;

        var container = document.querySelector('.vts-reminder-edit');

        jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/vyb/' + app.vyb.key + '/reminders/' + reminderId,
            type: 'DELETE',
            success: function(response) {
                if (response.result === 1) {
                    app.vyb.updateTriggerSettings(function(ts){
                        if (ts.reminders) ts.reminders = ts.reminders.filter(function(r) { return r.id !== reminderId; });
                    });
                    if (container) app.utils._renderReminderList(container.querySelector('.vts-reminder-list'));
                }
            },
            error: function() {
                console.log('Error deleting reminder ' + reminderId);
            }
        }, app.utils.setAuthTokenHeader()));
    },

    clearNotificationFields: function(event){
        if(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const fields = {message: '', log: '', imageUrl: '', linkUrl: ''};

        app.vyb.set(fields, {silent: true});

        Object.keys(fields).forEach(function(field){
            app.vyb.trigger('change:' + field, app.vyb, '');
        });

        app.vyb.save(fields, {patch: true, silent: true});
    }
});

module.exports = VybFullView;
